module.exports = __webpack_public_path__ + "static/img/287634.8418f40d.png";